/*
? First, let's import the global state interface.
*/

import StateInterface from "../state-interface";

/*
& Now let's describe an initial state for the faq object. This is the state that will be used when the app first fires up. Think of it like a placeholder.
*/

const faq_data: StateInterface["faq"] = {
	_id: "",
	ref: 1,
	slug: "",
	category: "",
	category_description: "",
	subcategory: "",
	subcategory_description: "",
	question: "",
	answer: "",
	more: [],
	upvotes: [],
	downvotes: [],
	featured: false,
	published: false,
	published_at: "",
	deleted: false,
	deleted_at: "",
	created_at: "",
	updated_at: "",
};

export const faq = faq_data;
export default faq_data;
